import React from "react";
import { Grid, IconButton, makeStyles, Paper, Tooltip, Typography } from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({}));

const Part = (props) => {
  const { data, type = "part", handleOpenDialog = () => {}, handleOpenDeleteDialog = () => {}, canEdit } = props;

  const classes = useStyles();

  return (
    <Grid item xs={12} lg={3} style={{ paddingLeft: 10, paddingTop: 10 }}>
      <Paper style={{ padding: 10 }} variant='outlined'>
        <Grid container>
          <Grid item xs={10}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center'>
              <Typography style={{ fontWeight: "bold", fontSize: 15 }}>نام:</Typography>

              <Typography
                style={{
                  fontSize: 15,
                  marginRight: 5,
                }}
                color='textSecondary'
              >
                {data?.name?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>

            {data?.amount && (
              <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
                <Typography style={{ fontWeight: "bold", fontSize: 15 }}>
                  {type === "part" ? "مساحت" : "تعداد"}:
                </Typography>

                <Typography
                  style={{
                    fontSize: 15,
                    marginRight: 5,
                  }}
                  color='textSecondary'
                >
                  {data?.amount?.toString()?.toPersianDigits()}
                </Typography>
              </Grid>
            )}

            {data?.value && (
              <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
                <Typography style={{ fontWeight: "bold", fontSize: 15 }}>ارزش:</Typography>

                <Typography
                  style={{
                    fontSize: 15,
                    marginRight: 5,
                  }}
                  color='textSecondary'
                >
                  {data?.value
                    ?.replace(/\D/g, "")
                    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    ?.toString()
                    ?.toPersianDigits()}
                </Typography>
              </Grid>
            )}

            {data?.description && (
              <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
                <Typography style={{ fontWeight: "bold", fontSize: 15 }}>توضیحات:</Typography>

                <Typography
                  style={{
                    fontSize: 15,
                    marginRight: 5,
                  }}
                  color='textSecondary'
                >
                  {data?.description?.toString()?.toPersianDigits()}
                </Typography>
              </Grid>
            )}
          </Grid>
          {canEdit && (
            <Grid item xs={2}>
              <Tooltip title='ویرایش'>
                <IconButton onClick={() => handleOpenDialog(true, data, "edit")}>
                  <Edit />
                </IconButton>
              </Tooltip>

              <Tooltip title='حذف'>
                <IconButton onClick={() => handleOpenDeleteDialog(true, data)}>
                  <Delete />
                </IconButton>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default Part;
